/**
 * calcMonthlyPayment
 * @param amount сумма кредита
 * @param termInMonths срок кредита в месяцах
 * @param rateInPercentAmount ставка кредита в % (15%, 16.7% и пр)
 * @return number
 */

export function calcMonthlyPayment(amount: number, termInMonths: number, rateInPercentAmount: number) {
  const rate = rateInPercentAmount * 0.01;
  const ratePerMonth = rate / 12;
  const fullInterestRate = Math.pow(1 + ratePerMonth, termInMonths);
  const k = (ratePerMonth * fullInterestRate) / (fullInterestRate - 1);

  return Math.round(amount * k * 100) / 100;
}
